import { NoDataException } from 'src/com/sixdee/crbtportal/utils/exceptions/nodataexistsexception';
import { CreateFlashMessageDto, CreateFlashMessageDtoImpl } from './createflashmessagedto';

export class CreateFlashMessageBuilder
{
    constructor(flashMessageList: any)
    {
        if(flashMessageList.datas === undefined)
        {
            throw new NoDataException("CreateFlashMessage data doesnt exists");
        }
    }

    buildAll(): CreateFlashMessageDto
    {
        return this.parseCreateFlashMessageDetailsResponse();
    }
    
    private parseCreateFlashMessageDetailsResponse(): CreateFlashMessageDto
    {
      
        return new CreateFlashMessageDtoImpl();
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessage/create/flashmessagebuilder.ts